import styled from 'styled-components';
import { DEVELOPMENT_CONTENT_CARD_HEIGHT } from '../../constants';
import { LearnerCard } from '../LearnerCard';

export const StyledLearnerCard = styled(LearnerCard)`
  height: ${DEVELOPMENT_CONTENT_CARD_HEIGHT}px;
`;
